import type { VideoItem } from '@/types/video';

export const videos: VideoItem[] = [
  {
    id: 'ht-m1',
    title: '暗涌之城',
    type: 'movie',
    region: '中国大陆',
    year: 2024,
    rating: 8.6,
    quality: '蓝光高清',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20suspense%20movie%20poster%20of%20a%20rainy%20neon%20lit%20city%20street%20at%20night%2C%20lone%20silhouette%20holding%20an%20umbrella%2C%20moody%20dark%20tones%20with%20deep%20red%20and%20amber%20lighting%2C%20dramatic%20contrast%2C%20vertical%20composition%2C%20high%20detail&width=600&height=840&seq=ht-poster-m1&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rainy%20empty%20city%20intersection%20at%20night%20with%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20red%20and%20amber%20glow%2C%20film%20noir%20mood%2C%20high%20detail&width=1600&height=900&seq=ht-poster-m1-bd&orientation=landscape',
    synopsis: '一桩看似普通的失踪案，牵出城市暗面盘根错节的利益网络。刑警队长林岸在追查真相的过程中，逐渐发现自己最信任的搭档也牵涉其中。雨夜、霓虹与谎言交织，他必须在坍塌的秩序里守住最后一点是非。',
    cast: ['周慕白', '陆晓安', '贺文川', '苏晴'],
    director: '陈亦然',
    duration: '128 分钟',
    status: '已完结',
    playCount: 2840000,
    tags: ['悬疑', '犯罪', '都市'],
    episodes: [{ id: 'ht-m1-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-m2',
    title: '星际归途',
    type: 'movie',
    region: '美国',
    year: 2023,
    rating: 9.1,
    quality: '4K HDR',
    cover: 'https://readdy.ai/api/search-image?query=epic%20sci%20fi%20movie%20poster%20of%20an%20astronaut%20silhouette%20before%20a%20giant%20planet%20ring%2C%20deep%20space%20nebula%20in%20warm%20orange%20and%20crimson%2C%20dramatic%20rim%20light%2C%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=840&seq=ht-poster-m2&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=vast%20space%20scene%20with%20a%20ringed%20planet%20and%20warm%20nebula%20clouds%2C%20small%20spaceship%20trailing%20light%2C%20cinematic%20orange%20and%20crimson%20palette%2C%20epic%20scale%2C%20high%20detail&width=1600&height=900&seq=ht-poster-m2-bd&orientation=landscape',
    synopsis: '人类最后的深空科考飞船在返航途中失去联系，导航员艾拉发现飞船正被一股未知引力拖向未知星域。为了带船员回家，她必须解开一段被刻意抹去的航行日志，在孤独与恐惧中做出抉择。',
    cast: ['Ethan Cole', 'Mara Vance', 'Julian Reyes'],
    director: 'Adrian Wolfe',
    duration: '146 分钟',
    status: '已完结',
    playCount: 3620000,
    tags: ['科幻', '冒险', '太空'],
    episodes: [{ id: 'ht-m2-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-m3',
    title: '雪山来客',
    type: 'movie',
    region: '中国大陆',
    year: 2022,
    rating: 8.2,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20lone%20figure%20walking%20in%20heavy%20snow%20toward%20a%20remote%20wooden%20lodge%2C%20cold%20blue%20gray%20snow%20with%20warm%20window%20light%2C%20minimal%20composition%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-m3&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=snowy%20mountain%20landscape%20at%20dusk%20with%20a%20small%20warm%20lit%20cabin%2C%20soft%20falling%20snow%2C%20cool%20gray%20blue%20tones%20with%20amber%20window%20glow%2C%20minimal%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-m3-bd&orientation=landscape',
    synopsis: '失意的城市青年被迫回到高原故乡，接手祖父留下的雪山客栈。在漫长而寂静的冬天里，他与一位不请自来的旅人相遇，两个各自带着伤口的人，在风雪与柴火之间慢慢学会告别。',
    cast: ['赵远山', '林知夏', '乌日娜'],
    director: '白嘉树',
    duration: '112 分钟',
    status: '已完结',
    playCount: 1290000,
    tags: ['剧情', '治愈', '人生'],
    episodes: [{ id: 'ht-m3-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-m4',
    title: '午夜特快',
    type: 'movie',
    region: '中国香港',
    year: 2024,
    rating: 8.8,
    quality: '蓝光高清',
    cover: 'https://readdy.ai/api/search-image?query=high%20octane%20action%20movie%20poster%20of%20a%20speeding%20subway%20train%20in%20a%20dark%20tunnel%20with%20sparks%2C%20silhouette%20of%20a%20man%20running%20on%20the%20roof%2C%20explosive%20orange%20and%20red%20lighting%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-m4&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=action%20scene%20of%20a%20high%20speed%20train%20racing%20through%20a%20dark%20city%20tunnel%20with%20sparks%20flying%2C%20motion%20blur%2C%20dramatic%20orange%20and%20red%20lighting%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-m4-bd&orientation=landscape',
    synopsis: '末班地铁上，一名退役特警意外卷入一场精心策划的劫案。列车在隧道中失控加速，乘客命悬一线。三十五分钟之内，他必须找出混在人群里的内应，并阻止幕后主使抵达终点站。',
    cast: ['麦子豪', '何丽芯', '郭兆铭'],
    director: '郑伟立',
    duration: '119 分钟',
    status: '已完结',
    playCount: 2470000,
    tags: ['动作', '犯罪', '惊险'],
    episodes: [{ id: 'ht-m4-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-m5',
    title: '假如爱有天意',
    type: 'movie',
    region: '韩国',
    year: 2021,
    rating: 8.4,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20korean%20movie%20poster%20of%20a%20couple%20under%20a%20street%20lamp%20in%20autumn%20rain%2C%20warm%20amber%20bokeh%20lights%2C%20soft%20gentle%20tones%2C%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=840&seq=ht-poster-m5&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=autumn%20evening%20street%20with%20yellow%20falling%20leaves%20and%20warm%20street%20lamps%2C%20two%20distant%20figures%20walking%20side%20by%20side%2C%20soft%20golden%20bokeh%2C%20romantic%20cinematic%20tone&width=1600&height=900&seq=ht-poster-m5-bd&orientation=landscape',
    synopsis: '一封迟到十年的信，让两个早已走散的人重新回到起点。男孩成为天气预报员，女孩留在海边小镇守着旧书店。命运让他们一次次擦肩，又在同一个雨天把未说完的话重新递到面前。',
    cast: ['宋恩彩', '姜智恩', '朴度延'],
    director: '尹夏琳',
    duration: '124 分钟',
    status: '已完结',
    playCount: 1980000,
    tags: ['爱情', '剧情', '治愈'],
    episodes: [{ id: 'ht-m5-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-m6',
    title: '深海回响',
    type: 'movie',
    region: '英国',
    year: 2023,
    rating: 8.7,
    quality: '4K HDR',
    cover: 'https://readdy.ai/api/search-image?query=underwater%20thriller%20movie%20poster%20of%20a%20deep%20sea%20diver%20facing%20a%20vast%20dark%20trench%2C%20single%20diving%20light%20beam%2C%20teal%20and%20amber%20contrast%2C%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=840&seq=ht-poster-m6&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=deep%20ocean%20trench%20scene%20with%20a%20single%20submersible%20light%20beam%20cutting%20through%20dark%20water%2C%20marine%20snow%20particles%2C%20teal%20and%20amber%20tones%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-m6-bd&orientation=landscape',
    synopsis: '一支深海勘探队在无人海域接收到一段不属于任何已知设备的声呐回响。随着下潜深度不断增加，队员们开始听到同一种声音，并逐渐意识到，真正被勘探的或许是他们自己。',
    cast: ['Oliver Grant', 'Nadia Frost', 'Callum Reid'],
    director: 'Harriet Boyle',
    duration: '135 分钟',
    status: '已完结',
    playCount: 2150000,
    tags: ['冒险', '惊悚', '海洋'],
    episodes: [{ id: 'ht-m6-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-m7',
    title: '归墟迷航',
    type: 'movie',
    region: '中国大陆',
    year: 2025,
    rating: 8.9,
    quality: '4K HDR',
    cover: 'https://readdy.ai/api/search-image?query=futuristic%20sci%20fi%20movie%20poster%20of%20a%20floating%20ancient%20city%20ruin%20above%20clouds%20with%20glowing%20red%20energy%20lines%2C%20lone%20traveler%20silhouette%2C%20epic%20vertical%20composition%2C%20high%20detail&width=600&height=840&seq=ht-poster-m7&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20sci%20fi%20landscape%20of%20a%20floating%20ancient%20city%20above%20a%20sea%20of%20clouds%2C%20glowing%20red%20energy%20veins%2C%20dramatic%20scale%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-m7-bd&orientation=landscape',
    synopsis: '在资源枯竭的未来，一支探险队循着古老星图寻找传说中漂浮于云海之上的「归墟」。当他们真正抵达时，却发现这座遗迹仍在运转，而守护它的秘密远比财富更沉重。',
    cast: ['沈墨言', '许清和', '罗天一'],
    director: '高远',
    duration: '152 分钟',
    status: '已完结',
    playCount: 3100000,
    tags: ['科幻', '冒险', '悬疑'],
    episodes: [{ id: 'ht-m7-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-m8',
    title: '江湖夜雨',
    type: 'movie',
    region: '中国大陆',
    year: 2020,
    rating: 8.1,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20wuxia%20movie%20poster%20of%20a%20swordsman%20in%20a%20rainy%20bamboo%20forest%20at%20night%2C%20flowing%20robes%2C%20cool%20green%20and%20warm%20amber%20lantern%20light%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-m8&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=rainy%20chinese%20bamboo%20forest%20at%20night%20with%20a%20lone%20swordsman%20standing%20still%2C%20mist%2C%20warm%20lantern%20glow%2C%20cinematic%20wide%20shot%20wuxia%20style&width=1600&height=900&seq=ht-poster-m8-bd&orientation=landscape',
    synopsis: '江湖十年，恩怨未了。退隐的剑客为送故人之女归乡，重踏旧路，一路上旧敌新友接踵而至。他原以为只要不再拔剑就能了结过往，却发现有些债，只能用一次抉择来还。',
    cast: ['江砚舟', '叶柔云', '穆长风'],
    director: '傅临安',
    duration: '118 分钟',
    status: '已完结',
    playCount: 1420000,
    tags: ['武侠', '古装', '剧情'],
    episodes: [{ id: 'ht-m8-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-m9',
    title: '逆风翻盘',
    type: 'movie',
    region: '中国大陆',
    year: 2024,
    rating: 8.3,
    quality: '蓝光高清',
    cover: 'https://readdy.ai/api/search-image?query=inspiring%20sports%20drama%20movie%20poster%20of%20a%20basketball%20player%20leaping%20in%20mid%20air%20in%20a%20warm%20lit%20gym%2C%20sweat%20and%20motion%2C%20energetic%20red%20and%20amber%20lighting%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-m9&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=indoor%20basketball%20court%20with%20warm%20amber%20spotlights%20and%20a%20silhouette%20of%20a%20player%20dunking%2C%20dynamic%20motion%2C%20energetic%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-m9-bd&orientation=landscape',
    synopsis: '一支被解散边缘的社区篮球队，迎来了人生最失意的年轻教练。没有天赋，没有经费，只有一群不肯认输的人。当所有人都觉得他们只是陪跑时，他们决定把每一场比赛都当成最后一战。',
    cast: ['韩子墨', '程亦诺', '田嘉豪'],
    director: '马思远',
    duration: '125 分钟',
    status: '已完结',
    playCount: 1680000,
    tags: ['励志', '运动', '青春'],
    episodes: [{ id: 'ht-m9-ep1', index: 1, title: '正片' }],
  },
  {
    id: 'ht-t1',
    title: '长夜将明',
    type: 'tv',
    region: '中国大陆',
    year: 2024,
    rating: 9.0,
    quality: '4K HDR',
    cover: 'https://readdy.ai/api/search-image?query=crime%20drama%20series%20poster%20of%20a%20detective%20standing%20in%20a%20dark%20rainy%20alley%20lit%20by%20a%20single%20orange%20street%20lamp%2C%20tense%20moody%20atmosphere%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t1&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=moody%20night%20city%20alley%20in%20the%20rain%20with%20orange%20street%20lamp%20glow%20and%20wet%20reflections%2C%20cinematic%20crime%20drama%20wide%20shot&width=1600&height=900&seq=ht-poster-t1-bd&orientation=landscape',
    synopsis: '一起跨越十二年的悬案重新浮出水面，年轻的检察官与固执的老刑警被迫联手。随着调查深入，他们发现案件背后牵动的，是一座城市不愿被提起的往事，以及彼此都无法回避的过去。',
    cast: ['罗景行', '方知远', '温若宁', '高博'],
    director: '徐成钢',
    duration: '45 分钟 / 集',
    status: '更新至 8 集',
    playCount: 4250000,
    tags: ['悬疑', '犯罪', '刑侦'],
    episodes: [
      { id: 'ht-t1-ep1', index: 1, title: '第1集 · 雨夜档案' },
      { id: 'ht-t1-ep2', index: 2, title: '第2集 · 沉默证人' },
      { id: 'ht-t1-ep3', index: 3, title: '第3集 · 十二年前' },
      { id: 'ht-t1-ep4', index: 4, title: '第4集 · 失踪的证物' },
      { id: 'ht-t1-ep5', index: 5, title: '第5集 · 旧日同事' },
      { id: 'ht-t1-ep6', index: 6, title: '第6集 · 暗线' },
      { id: 'ht-t1-ep7', index: 7, title: '第7集 · 崩塌' },
      { id: 'ht-t1-ep8', index: 8, title: '第8集 · 长夜将明' },
    ],
  },
  {
    id: 'ht-t2',
    title: '繁花似锦',
    type: 'tv',
    region: '中国大陆',
    year: 2023,
    rating: 8.5,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=urban%20drama%20series%20poster%20of%20an%20elegant%20woman%20in%20a%20modern%20city%20skyline%20at%20dusk%2C%20warm%20amber%20and%20rose%20tones%2C%20sophisticated%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t2&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20dusk%20with%20warm%20amber%20and%20rose%20light%2C%20glowing%20office%20windows%2C%20sophisticated%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-t2-bd&orientation=landscape',
    synopsis: '三个性格迥异的女孩在都市中打拼，从初入职场的青涩到独当一面的从容。她们分享出租屋、分享秘密，也分享彼此最难熬的夜晚，在纷繁的现实里守住属于自己的那束光。',
    cast: ['苏念安', '林薇', '江晚棠', '张予舟'],
    director: '李婉',
    duration: '42 分钟 / 集',
    status: '全 8 集',
    playCount: 3380000,
    tags: ['都市', '情感', '成长'],
    episodes: [
      { id: 'ht-t2-ep1', index: 1, title: '第1集 · 初来乍到' },
      { id: 'ht-t2-ep2', index: 2, title: '第2集 · 合租生活' },
      { id: 'ht-t2-ep3', index: 3, title: '第3集 · 第一次升职' },
      { id: 'ht-t2-ep4', index: 4, title: '第4集 · 说不出口的话' },
      { id: 'ht-t2-ep5', index: 5, title: '第5集 · 各自的战场' },
      { id: 'ht-t2-ep6', index: 6, title: '第6集 · 风雨同舟' },
      { id: 'ht-t2-ep7', index: 7, title: '第7集 · 选择' },
      { id: 'ht-t2-ep8', index: 8, title: '第8集 · 繁花似锦' },
    ],
  },
  {
    id: 'ht-t3',
    title: '时间潜行者',
    type: 'tv',
    region: '美国',
    year: 2024,
    rating: 8.8,
    quality: '4K HDR',
    cover: 'https://readdy.ai/api/search-image?query=sci%20fi%20series%20poster%20of%20a%20figure%20dissolving%20into%20glowing%20time%20particles%20with%20concentric%20clock%20rings%2C%20emerald%20and%20amber%20glow%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t3&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=abstract%20time%20travel%20visual%20with%20concentric%20glowing%20clock%20rings%20and%20particle%20streaks%20in%20emerald%20and%20amber%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-t3-bd&orientation=landscape',
    synopsis: '一群被时间异常抛离轨道的「潜行者」，靠修正历史裂缝维持自己的存在。每修复一处混乱，他们就会失去一段真实记忆。当队长的记忆即将被彻底清零，他必须决定要拯救世界，还是留住自己是谁。',
    cast: ['Lucas Hale', 'Nina Blake', 'Theo Marsh'],
    director: 'Gregory Shaw',
    duration: '48 分钟 / 集',
    status: '更新至 8 集',
    playCount: 2760000,
    tags: ['科幻', '悬疑', '时间'],
    episodes: [
      { id: 'ht-t3-ep1', index: 1, title: '第1集 · 裂缝' },
      { id: 'ht-t3-ep2', index: 2, title: '第2集 · 循环' },
      { id: 'ht-t3-ep3', index: 3, title: '第3集 · 消失的早晨' },
      { id: 'ht-t3-ep4', index: 4, title: '第4集 · 双生' },
      { id: 'ht-t3-ep5', index: 5, title: '第5集 · 记忆代价' },
      { id: 'ht-t3-ep6', index: 6, title: '第6集 · 支点' },
      { id: 'ht-t3-ep7', index: 7, title: '第7集 · 逆流' },
      { id: 'ht-t3-ep8', index: 8, title: '第8集 · 归零' },
    ],
  },
  {
    id: 'ht-t4',
    title: '家宴',
    type: 'tv',
    region: '中国大陆',
    year: 2022,
    rating: 8.6,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=heartwarming%20family%20drama%20poster%20of%20a%20long%20family%20dinner%20table%20lit%20by%20warm%20hanging%20lamps%2C%20steaming%20dishes%2C%20cozy%20amber%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t4&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cozy%20family%20dining%20room%20with%20a%20long%20table%20full%20of%20home%20cooked%20dishes%20and%20warm%20hanging%20lanterns%2C%20inviting%20amber%20tones%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-t4-bd&orientation=landscape',
    synopsis: '一间老字号饭馆见证了三代人的聚散离合。每逢年节，散落各地的家人都会回到这张餐桌前。一道道家常菜背后，藏着说不出口的关心，也藏着这个家庭最真实的温度。',
    cast: ['周国立', '许淑芬', '周文杰', '周小雨'],
    director: '韩守仁',
    duration: '40 分钟 / 集',
    status: '全 8 集',
    playCount: 1890000,
    tags: ['家庭', '温情', '美食'],
    episodes: [
      { id: 'ht-t4-ep1', index: 1, title: '第1集 · 年夜饭' },
      { id: 'ht-t4-ep2', index: 2, title: '第2集 · 老味道' },
      { id: 'ht-t4-ep3', index: 3, title: '第3集 · 远行的人' },
      { id: 'ht-t4-ep4', index: 4, title: '第4集 · 一张旧照片' },
      { id: 'ht-t4-ep5', index: 5, title: '第5集 · 重逢' },
      { id: 'ht-t4-ep6', index: 6, title: '第6集 · 难念的经' },
      { id: 'ht-t4-ep7', index: 7, title: '第7集 · 灯火可亲' },
      { id: 'ht-t4-ep8', index: 8, title: '第8集 · 回家' },
    ],
  },
  {
    id: 'ht-t5',
    title: '破晓行动',
    type: 'tv',
    region: '中国大陆',
    year: 2024,
    rating: 8.7,
    quality: '蓝光高清',
    cover: 'https://readdy.ai/api/search-image?query=police%20action%20series%20poster%20of%20a%20tactical%20team%20silhouette%20advancing%20at%20dawn%20with%20orange%20sunrise%20glow%20and%20red%20sirens%2C%20tense%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t5&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=city%20skyline%20at%20dawn%20with%20orange%20sunrise%20glow%20and%20red%20and%20blue%20emergency%20light%20reflections%2C%20tactical%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-t5-bd&orientation=landscape',
    synopsis: '一支以年轻人为主的特别行动小组，专攻城市中最棘手的突发案件。枪火之外，他们要面对的是更复杂的抉择与牺牲。每一次出击，都是为了让更多人平安迎来破晓。',
    cast: ['程锋', '覃雨桐', '梁毅', '许静'],
    director: '罗志刚',
    duration: '44 分钟 / 集',
    status: '更新至 8 集',
    playCount: 3010000,
    tags: ['刑侦', '动作', '悬疑'],
    episodes: [
      { id: 'ht-t5-ep1', index: 1, title: '第1集 · 紧急集合' },
      { id: 'ht-t5-ep2', index: 2, title: '第2集 · 无声对峙' },
      { id: 'ht-t5-ep3', index: 3, title: '第3集 · 迷雾追踪' },
      { id: 'ht-t5-ep4', index: 4, title: '第4集 · 一线之间' },
      { id: 'ht-t5-ep5', index: 5, title: '第5集 · 内线' },
      { id: 'ht-t5-ep6', index: 6, title: '第6集 · 撤离令' },
      { id: 'ht-t5-ep7', index: 7, title: '第7集 · 最后一课' },
      { id: 'ht-t5-ep8', index: 8, title: '第8集 · 破晓行动' },
    ],
  },
  {
    id: 'ht-t6',
    title: '樱花季节',
    type: 'tv',
    region: '日本',
    year: 2021,
    rating: 8.3,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=japanese%20romance%20series%20poster%20of%20a%20couple%20cycling%20under%20pink%20cherry%20blossom%20trees%2C%20soft%20pastel%20warm%20light%2C%20gentle%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t6&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=quiet%20japanese%20town%20street%20lined%20with%20blooming%20cherry%20blossom%20trees%20in%20soft%20warm%20light%2C%20gentle%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-t6-bd&orientation=landscape',
    synopsis: '在樱花开的那个春天，转校生遇见了总是独自坐在河堤上的少年。两人因为一本旧诗集相识，又在一年四季的更替中慢慢靠近。这是关于青春、勇气与告别的温柔故事。',
    cast: ['佐藤美咲', '高桥悠真', '小林枫'],
    director: '中村晴',
    duration: '38 分钟 / 集',
    status: '全 8 集',
    playCount: 1540000,
    tags: ['爱情', '青春', '治愈'],
    episodes: [
      { id: 'ht-t6-ep1', index: 1, title: '第1集 · 春日来信' },
      { id: 'ht-t6-ep2', index: 2, title: '第2集 · 河堤少年' },
      { id: 'ht-t6-ep3', index: 3, title: '第3集 · 旧诗集' },
      { id: 'ht-t6-ep4', index: 4, title: '第4集 · 夏日祭' },
      { id: 'ht-t6-ep5', index: 5, title: '第5集 · 未寄出的信' },
      { id: 'ht-t6-ep6', index: 6, title: '第6集 · 秋风起' },
      { id: 'ht-t6-ep7', index: 7, title: '第7集 · 初雪' },
      { id: 'ht-t6-ep8', index: 8, title: '第8集 · 再见的季节' },
    ],
  },
  {
    id: 'ht-t7',
    title: '权力之巅',
    type: 'tv',
    region: '英国',
    year: 2023,
    rating: 9.2,
    quality: '4K HDR',
    cover: 'https://readdy.ai/api/search-image?query=prestige%20political%20drama%20series%20poster%20of%20a%20lone%20silhouette%20in%20a%20grand%20marble%20hall%20with%20golden%20light%20beams%2C%20dark%20tones%20with%20amber%20accents%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t7&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=grand%20classical%20marble%20hall%20with%20tall%20columns%20and%20dramatic%20golden%20light%20beams%2C%20empty%20and%20imposing%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-t7-bd&orientation=landscape',
    synopsis: '一场突如其来的权力更迭，让原本默默无闻的幕僚被推上风口浪尖。在纵横捭阖的博弈中，他逐渐明白，站得越高，能信任的人就越少。这场游戏的筹码，是他一路走来的全部信念。',
    cast: ['Henry Ashford', 'Eleanor Vane', 'Marcus Doyle'],
    director: 'Peter Hale',
    duration: '52 分钟 / 集',
    status: '更新至 8 集',
    playCount: 2290000,
    tags: ['权谋', '剧情', '悬疑'],
    episodes: [
      { id: 'ht-t7-ep1', index: 1, title: '第1集 · 空缺' },
      { id: 'ht-t7-ep2', index: 2, title: '第2集 · 站队' },
      { id: 'ht-t7-ep3', index: 3, title: '第3集 · 交易' },
      { id: 'ht-t7-ep4', index: 4, title: '第4集 · 泄密' },
      { id: 'ht-t7-ep5', index: 5, title: '第5集 · 反将一军' },
      { id: 'ht-t7-ep6', index: 6, title: '第6集 · 旧盟友' },
      { id: 'ht-t7-ep7', index: 7, title: '第7集 · 孤注一掷' },
      { id: 'ht-t7-ep8', index: 8, title: '第8集 · 权力之巅' },
    ],
  },
  {
    id: 'ht-t8',
    title: '山海食堂',
    type: 'tv',
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=healing%20food%20drama%20poster%20of%20a%20small%20cozy%20night%20food%20stall%20with%20steaming%20bowls%20and%20warm%20red%20lanterns%2C%20inviting%20amber%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t8&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cozy%20night%20food%20stall%20alley%20with%20warm%20red%20lanterns%20and%20steaming%20dishes%2C%20inviting%20amber%20glow%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-t8-bd&orientation=landscape',
    synopsis: '一间开在山海之间的小食堂，只在夜里营业。老板从不问客人的来处，只用心做一碗热汤。每一集都是一段陌生的相遇，也是一顿能把人重新暖过来的家常饭。',
    cast: ['郑海生', '苏婉', '老陈'],
    director: '林一诺',
    duration: '35 分钟 / 集',
    status: '更新至 8 集',
    playCount: 1720000,
    tags: ['治愈', '美食', '温情'],
    episodes: [
      { id: 'ht-t8-ep1', index: 1, title: '第1集 · 一碗面' },
      { id: 'ht-t8-ep2', index: 2, title: '第2集 · 深夜客人' },
      { id: 'ht-t8-ep3', index: 3, title: '第3集 · 老家的味道' },
      { id: 'ht-t8-ep4', index: 4, title: '第4集 · 两个人的桌' },
      { id: 'ht-t8-ep5', index: 5, title: '第5集 · 雨季' },
      { id: 'ht-t8-ep6', index: 6, title: '第6集 · 招牌菜' },
      { id: 'ht-t8-ep7', index: 7, title: '第7集 · 远方的信' },
      { id: 'ht-t8-ep8', index: 8, title: '第8集 · 山海再会' },
    ],
  },
  {
    id: 'ht-t9',
    title: '迷失代码',
    type: 'tv',
    region: '德国',
    year: 2022,
    rating: 8.5,
    quality: '蓝光高清',
    cover: 'https://readdy.ai/api/search-image?query=tech%20thriller%20series%20poster%20of%20a%20lone%20programmer%20silhouette%20before%20a%20wall%20of%20glowing%20green%20and%20red%20code%2C%20dark%20cyber%20atmosphere%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-t9&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=dark%20server%20room%20with%20glowing%20red%20and%20green%20indicator%20lights%20and%20cables%2C%20moody%20cyber%20thriller%20wide%20shot&width=1600&height=900&seq=ht-poster-t9-bd&orientation=landscape',
    synopsis: '一名顶尖安全工程师发现公司核心系统里藏着一段不属于任何人的代码。当她越靠近真相，现实中的意外就越多。责任、恐惧与好奇交织，她必须在代码吞噬一切之前按下那个不该按的键。',
    cast: ['Lena Fischer', 'Jonas Weber', 'Klara Berg'],
    director: 'Stefan Ritter',
    duration: '46 分钟 / 集',
    status: '全 8 集',
    playCount: 1360000,
    tags: ['科技', '惊悚', '悬疑'],
    episodes: [
      { id: 'ht-t9-ep1', index: 1, title: '第1集 · 异常日志' },
      { id: 'ht-t9-ep2', index: 2, title: '第2集 · 影子账户' },
      { id: 'ht-t9-ep3', index: 3, title: '第3集 · 被跟踪' },
      { id: 'ht-t9-ep4', index: 4, title: '第4集 · 后门' },
      { id: 'ht-t9-ep5', index: 5, title: '第5集 · 断网之夜' },
      { id: 'ht-t9-ep6', index: 6, title: '第6集 · 复制' },
      { id: 'ht-t9-ep7', index: 7, title: '第7集 · 归零风险' },
      { id: 'ht-t9-ep8', index: 8, title: '第8集 · 迷失代码' },
    ],
  },
  {
    id: 'ht-v1',
    title: '星火之夜',
    type: 'variety',
    region: '中国大陆',
    year: 2025,
    rating: 8.9,
    quality: '4K HDR',
    cover: 'https://readdy.ai/api/search-image?query=music%20show%20poster%20of%20a%20singer%20silhouette%20under%20a%20burst%20of%20warm%20orange%20stage%20spotlights%20and%20sparks%2C%20energetic%20vibrant%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-v1&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=grand%20concert%20stage%20with%20warm%20orange%20spotlights%20and%20a%20crowd%20silhouette%2C%20dynamic%20energetic%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-v1-bd&orientation=landscape',
    synopsis: '一档汇集实力唱将的音乐竞演节目，每一期都以不同主题重新演绎经典与新作。舞台之上是声音的对决，舞台之下是音乐人真实的热爱与坚持。这一夜，让好歌被更多人听见。',
    cast: ['曼宁', '周予安', '孙澈', '林小满'],
    director: '星火制作组',
    duration: '90 分钟 / 期',
    status: '更新至 6 期',
    playCount: 5120000,
    tags: ['音乐', '竞演', '现场'],
    episodes: [
      { id: 'ht-v1-ep1', index: 1, title: '第1期 · 初见' },
      { id: 'ht-v1-ep2', index: 2, title: '第2期 · 经典重唱' },
      { id: 'ht-v1-ep3', index: 3, title: '第3期 · 原创之夜' },
      { id: 'ht-v1-ep4', index: 4, title: '第4期 · 合作舞台' },
      { id: 'ht-v1-ep5', index: 5, title: '第5期 · 淘汰赛' },
      { id: 'ht-v1-ep6', index: 6, title: '第6期 · 星火之夜' },
    ],
  },
  {
    id: 'ht-v2',
    title: '极限出发',
    type: 'variety',
    region: '中国大陆',
    year: 2024,
    rating: 8.6,
    quality: '蓝光高清',
    cover: 'https://readdy.ai/api/search-image?query=outdoor%20adventure%20show%20poster%20of%20hikers%20on%20a%20mountain%20ridge%20at%20sunrise%20with%20orange%20sky%2C%20energetic%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-v2&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=sweeping%20mountain%20ridge%20at%20sunrise%20with%20warm%20orange%20sky%20and%20tiny%20hiker%20silhouettes%2C%20adventurous%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-v2-bd&orientation=landscape',
    synopsis: '一群嘉宾从城市出发，走向山川湖海，在没有剧本的旅程里完成一个又一个看似不可能的任务。他们在极限中互相扶持，也在风景里重新认识了彼此与自己。',
    cast: ['艾力', '苏禾', '大鹏', '可可'],
    director: '极限工作室',
    duration: '85 分钟 / 期',
    status: '更新至 6 期',
    playCount: 3870000,
    tags: ['户外', '真人秀', '冒险'],
    episodes: [
      { id: 'ht-v2-ep1', index: 1, title: '第1期 · 集合' },
      { id: 'ht-v2-ep2', index: 2, title: '第2期 · 出发' },
      { id: 'ht-v2-ep3', index: 3, title: '第3期 · 攀上第一座山' },
      { id: 'ht-v2-ep4', index: 4, title: '第4期 · 荒野之夜' },
      { id: 'ht-v2-ep5', index: 5, title: '第5期 · 意外' },
      { id: 'ht-v2-ep6', index: 6, title: '第6期 · 抵达终点' },
    ],
  },
  {
    id: 'ht-v3',
    title: '快乐星球',
    type: 'variety',
    region: '中国大陆',
    year: 2023,
    rating: 8.2,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=fun%20variety%20show%20poster%20of%20colorful%20playful%20props%20and%20a%20spotlight%20on%20a%20whimsical%20stage%2C%20warm%20orange%20and%20red%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-v3&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=colorful%20playful%20game%20show%20stage%20with%20warm%20orange%20and%20red%20lighting%20and%20fun%20props%2C%20energetic%20wide%20shot&width=1600&height=900&seq=ht-poster-v3-bd&orientation=landscape',
    synopsis: '这是一档让人从头笑到尾的欢乐综艺。嘉宾们被分成两队，在花样百出的游戏环节里斗智斗勇。输赢不重要，重要的是每一次翻车都能变成全场爆笑的名场面。',
    cast: ['何欢', '杜宇', '小北', '嘉嘉'],
    director: '快乐制造局',
    duration: '80 分钟 / 期',
    status: '更新至 6 期',
    playCount: 4180000,
    tags: ['综艺', '欢乐', '游戏'],
    episodes: [
      { id: 'ht-v3-ep1', index: 1, title: '第1期 · 开播大作战' },
      { id: 'ht-v3-ep2', index: 2, title: '第2期 · 智力大比拼' },
      { id: 'ht-v3-ep3', index: 3, title: '第3期 · 体力挑战赛' },
      { id: 'ht-v3-ep4', index: 4, title: '第4期 · 默契考验' },
      { id: 'ht-v3-ep5', index: 5, title: '第5期 · 反转之夜' },
      { id: 'ht-v3-ep6', index: 6, title: '第6期 · 快乐星球' },
    ],
  },
  {
    id: 'ht-v4',
    title: '厨房大作战',
    type: 'variety',
    region: '中国大陆',
    year: 2024,
    rating: 8.5,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=cooking%20show%20poster%20of%20a%20chef%20flambeing%20a%20pan%20with%20orange%20fire%20in%20a%20warm%20lit%20kitchen%2C%20appetizing%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-v4&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=warm%20professional%20kitchen%20with%20steam%20and%20orange%20flame%20from%20pans%2C%20appetizing%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-v4-bd&orientation=landscape',
    synopsis: '来自不同菜系的厨师同台竞技，限时、限料、限主题，用一道菜一决高下。评委的每一句点评都毫不留情，而厨房里的临时状况，往往比菜单更考验真功夫。',
    cast: ['谭师傅', '林月', '阿明', '周厨'],
    director: '味觉工作室',
    duration: '75 分钟 / 期',
    status: '更新至 6 期',
    playCount: 2650000,
    tags: ['美食', '竞技', '生活'],
    episodes: [
      { id: 'ht-v4-ep1', index: 1, title: '第1期 · 开场菜' },
      { id: 'ht-v4-ep2', index: 2, title: '第2期 · 家乡味' },
      { id: 'ht-v4-ep3', index: 3, title: '第3期 · 三十分钟' },
      { id: 'ht-v4-ep4', index: 4, title: '第4期 · 神秘食材' },
      { id: 'ht-v4-ep5', index: 5, title: '第5期 · 半决赛' },
      { id: 'ht-v4-ep6', index: 6, title: '第6期 · 冠军之战' },
    ],
  },
  {
    id: 'ht-v5',
    title: '偶像直播间',
    type: 'variety',
    region: '韩国',
    year: 2023,
    rating: 8.1,
    quality: '高清',
    cover: 'https://readdy.ai/api/search-image?query=kpop%20audition%20show%20poster%20of%20dancers%20silhouette%20under%20warm%20orange%20spotlights%20on%20a%20stage%2C%20glossy%20vibrant%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-v5&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=kpop%20audition%20stage%20with%20warm%20orange%20spotlights%20and%20mirrored%20floor%2C%20glossy%20energetic%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-v5-bd&orientation=landscape',
    synopsis: '数百位练习生为了同一个舞台同场竞技，从唱跳到舞台表现力，每一轮都有选手离开。聚光灯下，他们用汗水回应质疑，也让观众见证梦想一步步成真的过程。',
    cast: ['金智秀', '李书俊', '朴娜英', '崔贤'],
    director: '星光制作',
    duration: '95 分钟 / 期',
    status: '更新至 6 期',
    playCount: 3460000,
    tags: ['选秀', '音乐', '竞演'],
    episodes: [
      { id: 'ht-v5-ep1', index: 1, title: '第1期 · 初舞台' },
      { id: 'ht-v5-ep2', index: 2, title: '第2期 · 分级' },
      { id: 'ht-v5-ep3', index: 3, title: '第3期 · 位置评价' },
      { id: 'ht-v5-ep4', index: 4, title: '第4期 · 合作舞台' },
      { id: 'ht-v5-ep5', index: 5, title: '第5期 · 淘汰' },
      { id: 'ht-v5-ep6', index: 6, title: '第6期 · 最终舞台' },
    ],
  },
  {
    id: 'ht-v6',
    title: '旅行者说',
    type: 'variety',
    region: '中国大陆',
    year: 2022,
    rating: 8.7,
    quality: '蓝光高清',
    cover: 'https://readdy.ai/api/search-image?query=travel%20documentary%20show%20poster%20of%20a%20backpacker%20looking%20out%20over%20a%20warm%20sunset%20desert%20horizon%2C%20golden%20amber%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=840&seq=ht-poster-v6&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=sweeping%20desert%20horizon%20at%20golden%20sunset%20with%20a%20lone%20traveler%20walking%2C%20warm%20amber%20tones%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=ht-poster-v6-bd&orientation=landscape',
    synopsis: '不同年龄、不同职业的旅行者，在同一段旅程中分享各自的故事。镜头跟随他们的脚步，穿过山川与城镇，记录下那些关于出发、相遇与放下的真实瞬间。',
    cast: ['顾南', '程雨', '老周', '田甜'],
    director: '远方纪实',
    duration: '60 分钟 / 期',
    status: '全 6 期',
    playCount: 1180000,
    tags: ['旅行', '纪实', '人文'],
    episodes: [
      { id: 'ht-v6-ep1', index: 1, title: '第1期 · 出发' },
      { id: 'ht-v6-ep2', index: 2, title: '第2期 · 高原' },
      { id: 'ht-v6-ep3', index: 3, title: '第3期 · 海边小镇' },
      { id: 'ht-v6-ep4', index: 4, title: '第4期 · 古镇' },
      { id: 'ht-v6-ep5', index: 5, title: '第5期 · 雪山' },
      { id: 'ht-v6-ep6', index: 6, title: '第6期 · 归途' },
    ],
  },
];